import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Table, Form, Button } from 'react-bootstrap'
import * as Common from "../../Common";
import LocationSelector from '../../LocationSelector';
import { useNavigate } from 'react-router-dom';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import $ from "jquery";
import DatePicker from 'react-datepicker';
import Dialog from '../../Dialog';

function RepCommission() {
    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();

    const [oneLocation, setOneLocation] = useState("");
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [radioType, setRadioType] = useState("");
    const [userRight, setUserRight] = useState([]);
    const [mode, setMode] = useState("V");
    const [repData, setRepData] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    useEffect(() => {
        Common.callApi(Common.apiRight, [sid, 'all', 'REPORTS_TDS_COMMISSION'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/');
            }
        });
    }, []);

    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        setOneLocation(newLocationCode);
        setSelectedLocations(newSelectedItems);
        setRadioType(newRadioType);
    }

    const generateReport = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        } else if (fromDate > toDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var i = 0, msg = [];
        if ((radioType == 'O' && oneLocation == '0') || (radioType == 'S' && selectedLocations == [])) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((radioType == 'O' && oneLocation == '0') ? "Please select location." : '');
            msg[i++] = ((radioType == 'S' && selectedLocations == []) ? "Please select atleast one location." : '');
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else if (fromDate === null || toDate === null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (fromDate === null ? "From Date." : '');
            msg[i++] = (toDate === null ? "To Date." : '');
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else {
            const obj = {
                mode: mode,
                radioType: radioType,
                oneLocation: oneLocation,
                selectedLocations: selectedLocations,
                frmdate: Common.dateYMD(fromDate),
                todate: Common.dateYMD(toDate)
            }
            if (mode === "V") {
                Common.callApi(Common.apiCommission, [sid, "tdsreport", JSON.stringify(obj)], result => {
                    console.log(result);
                    $(".loader").hide();
                    setRepData(JSON.parse(result));
                });
            } else {
                $(".loader").hide();
                Common.callDownloadApiPost(Common.apiCommission, "post", [sid, 'tdsrepdownload', JSON.stringify(obj)]);
            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Commission TDS Report</h2>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Mode</Form.Label>
                            <Form.Select value={mode} onChange={e => setMode(e.target.value)}>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>From Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>To Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Location Filter</Form.Label><br />
                            <Col>
                                <LocationSelector onDataFromChild={handleDataFromChild} />
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3'>
                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={generateReport}>List</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Table responsive bordered striped>
                        <thead>
                            <tr>
                                <th>Agent Type</th>
                                <th>Code</th>
                                <th>Rate of TDS</th>
                                <th>Pan No.</th>
                                <th>Party Name</th>
                                <th>Taxable Amount</th>
                                <th>TDS Amount</th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                repData.map(item => (
                                    <tr>
                                        <td>{item.app_agent_type == "C" ? "Company" : "Non Company"}</td>
                                        <td>194H</td>
                                        <td>{item.tds_rate}</td>
                                        <td>{item.app_pan_no}</td>
                                        <td>{item.app_agent_name}</td>
                                        <td>{item.app_total_commission}</td>
                                        <td>{item.app_tds}</td>


                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </>
    )
}

export default RepCommission
